"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 *
 * @param {String} date - date is received as dd/mm/yyyy
 *
 * expect day to be between 1-31, month 1 - 12, year four digits
 *
 * @returns true is date is valid dob, Validation String other wise
 */
var ValidateDateOfBirth = function ValidateDateOfBirth() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var underageMessage = 'Age verification failed - You must be 18 years of age or over to order wine from this site.';
  var invalidAge = 'Invalid age, please confirm your birth year.';
  var isValidDOB = invalidAge;
  var regex = /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/i;

  if (date !== null && date !== undefined && regex.test(date)) {
    var dateArray = date.split('/'); // restructure to mm/dd/yyy

    var restructuredDate = "".concat(dateArray[1], "/").concat(dateArray[0], "/").concat(dateArray[2]);
    var birthday = new Date(restructuredDate);
    var ageDiff = Date.now() - birthday.getTime();
    var age = Math.abs(new Date(ageDiff).getUTCFullYear() - 1970);

    if (age < 18) {
      isValidDOB = underageMessage;
    } else if (age >= 18 && age < 120) {
      isValidDOB = true;
    }
  }

  return isValidDOB;
};

var _default = ValidateDateOfBirth;
exports["default"] = _default;